import { motion } from 'framer-motion'
import {
  HiCode,
  HiLink,
  HiCube,
  HiRefresh,
  HiArrowCircleUp,
  HiChartBar,
} from 'react-icons/hi'
import { SectionTitle } from '@/components/SectionTitle'
import { useLanguage } from '@/i18n/LanguageContext'

const serviceIcons = [
  {
    icon: HiCode,
  },
  {
    icon: HiLink,
  },
  {
    icon: HiCube,
  },
  {
    icon: HiRefresh,
  },
  {
    icon: HiArrowCircleUp,
  },
  {
    icon: HiChartBar,
  },
]

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
}

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
}

export function Servicos() {
  const { t } = useLanguage()

  const services = serviceIcons.map((entry, index) => ({
    icon: entry.icon,
    title: t.servicos.items[index].title,
    description: t.servicos.items[index].description,
  }))

  return (
    <section id="servicos" className="section-padding bg-slate-50">
      <div className="container-custom">
        <SectionTitle
          title={t.servicos.title}
          subtitle={t.servicos.subtitle}
        />
        <motion.div
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-50px' }}
        >
          {services.map((service) => (
            <motion.article
              key={service.title}
              variants={item}
              className="group rounded-2xl bg-white p-6 lg:p-8 shadow-sm border border-slate-200/80 hover:border-primary-200 hover:shadow-lg hover:shadow-primary-500/5 transition-all duration-300"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-colors duration-300">
                <service.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-4 text-xl font-bold text-slate-900">{service.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{service.description}</p>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
